import { useOrderContext } from "app/providers/OrderProvider";
import OrderLoader from "widgets/shared/order-loader";
import AppointmentCreated from "./partials/appointment-created";
import AppointmentLater from "./partials/appointment-later";
import { useEffect } from "react";
import { useOnPurchase } from "app/hooks/shared/analytics/useOnPurchase";
import ZakelijkBankTransferStatus from "./ZakelijkBankTransferStatus";

const Appointment = () => {
  const { order, isOrderFetching } = useOrderContext();

  const { sendOnDoorPurchaseAnalytics } = useOnPurchase();

  useEffect(() => {
    if (!order) return;

    // For door orders, by current logic the purchased GA4 events are set at the appointment pages
    sendOnDoorPurchaseAnalytics(order);
  }, [order]);

  if (order?.paymentStatus === "onAccount") {
    return <ZakelijkBankTransferStatus />;
  }
  return (
    <>
      {isOrderFetching ? (
        <OrderLoader />
      ) : order?.measurementDate ? (
        <AppointmentCreated />
      ) : (
        <AppointmentLater />
      )}
    </>
  );
};
export default Appointment;
